import * as Device from 'expo-device';
import * as Sentry from '@sentry/react-native';
import * as Updates from 'expo-updates';
import Constants from 'expo-constants';
import { SENTRY_DSN, getChannel } from '../../config/config';

export const captureException = async (error: any) => {
  console.error('Captured Exception:',error);
  Sentry.captureException(error);
};

export const setUser = (email: string, id: string) => {
  Sentry.setUser({ email, _id: id });
};

export const sentryInit = () => {
  const channel = getChannel();
  Sentry.init({
    dsn: SENTRY_DSN,
    debug: channel !== 'production',
    enableAutoSessionTracking: true,
    environment:channel
  });
  Sentry.setExtras({
    manifest: Updates.manifest,
    deviceYearClass: Device.deviceYearClass,
    linkingUri: Constants.linkingUri,
  });
  Sentry.setTag('deviceId', Constants.sessionId);
  Sentry.setTag('appOwnership', Constants.appOwnership || 'N/A');
  if (Constants.appOwnership === 'expo' && Constants.expoVersion) {
    Sentry.setTag('expoAppVersion', Constants.expoVersion);
  }
  Sentry.setTag('expoChannel', Updates.channel);
  Sentry.setTag('expoUpdateId', Updates.updateId);
  const manifest = Updates.manifest;
  const metadata = 'metadata' in manifest ? manifest.metadata : undefined;
  const updateGroup = metadata && 'updateGroup' in metadata ? metadata.updateGroup : undefined;
  if (typeof updateGroup === 'string') {
    Sentry.setTag('expoUpdateGroupId', updateGroup);
  }
};
